export const apiTokenCookieName = 'mz-wl-token'

export const CONFIGURATION_FORM_NAME = 'configurationForm'
export const CREATE_WHITELABE_FORM_NAME = 'CreateWhitelabelForm'
